import { privateApi, publicApi } from "@/core/api";

export type MaintenanceStatus = {
  active: boolean;
  start_at: string;
  end_at: string;
};

export type NttpcMaintenanceType = "web" | "file";

export type NttpcMaintenanceListItem = {
  id: string;
  type: NttpcMaintenanceType;
  start_at: string | null;
  end_at: string | null;
  enable: boolean;
  active_now: boolean;
};

export type UpdateNttpcMaintenancePayload = {
  start_at?: string | null;
  end_at?: string | null;
  enable: boolean;
};

const TYPE_LABELS: Record<NttpcMaintenanceType, string> = {
  file: "ファイル連携",
  web: "WEB API",
};

export function getMaintenanceTypeLabel(type: NttpcMaintenanceType): string {
  return TYPE_LABELS[type];
}

export function formatMaintenanceDisplayDatetime(
  value: string | null | undefined
): string {
  if (!value) {
    return "—";
  }
  return value.replace("T", " ");
}

export async function fetchMaintenanceStatus(): Promise<MaintenanceStatus> {
  const response = await privateApi.get<MaintenanceStatus>(
    "/admins/maintenance/nttpc-file"
  );
  return response.data;
}

export async function fetchMaintenanceStatusPublic(): Promise<MaintenanceStatus> {
  const response = await publicApi.get<MaintenanceStatus>(
    "/auth/maintenance/nttpc-file"
  );
  return response.data;
}

export async function fetchNttpcMaintenances(): Promise<NttpcMaintenanceListItem[]> {
  const response = await privateApi.get<{ items: NttpcMaintenanceListItem[] }>(
    "/admins/maintenance/nttpc-maintenances"
  );
  return response.data.items;
}

export async function updateNttpcMaintenance(
  id: string,
  payload: UpdateNttpcMaintenancePayload
): Promise<NttpcMaintenanceListItem> {
  const response = await privateApi.put<{ item: NttpcMaintenanceListItem }>(
    `/admins/maintenance/nttpc-maintenances/${id}`,
    payload
  );
  return response.data.item;
}
